import React, { useEffect } from 'react';
import ContentContainer from 'templates/content-container/contentContainer';
import WeekTabs from './weekTabs';
import Button, { ButtonSizes, ButtonThemes } from 'ui-components/button/button';
import './cloneWeek.scss';
import XGSSelect, { XGSSelectOption } from 'ui-components/xgs-select/xgsSelect';
import { LabelModes } from 'ui-components/molecules/labeled-inputs/labeledInput';
import { useState } from 'react';
import { useWeeks } from './hooks/useWeek';
import { useDispatch } from 'react-redux';
import { setStaticLoad } from 'slices/static-load/staticLoadSlice';
import { useSelector } from 'react-redux';
import { staticLoadSelector } from 'slices/static-load/staticLoadSlice';
import ContentContainerToolbar from 'ui-components/molecules/content-container-toolbar/contentContainerToolbar';
import { useHistory } from 'react-router-dom';
import CreateLaneSidebar from './sidebars/createLaneSidebar';

const WorkWithManifest: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const staticLoadSelectorData = useSelector(staticLoadSelector);

  const [selectedWeek, setSelectedWeek] = useState<XGSSelectOption | null>(null);
  const [weekOptions, setWeekOptions] = useState<XGSSelectOption[] | null>(null);

  const [isCreateLaneSidebarOpen, setIsCreateLaneSidebarOpen] = useState(false);

  const { data: weekOptionsData, isLoading: isLoadingWeeks } = useWeeks();

  useEffect(() => {
    if (weekOptionsData && weekOptionsData.length > 0) {
      setSelectedWeek({
        label: weekOptionsData[0].weekStartDate,
        value: weekOptionsData[0].weekStartDate,
      });
      dispatch(setStaticLoad({
        division: weekOptionsData[0].division,
        weekStartDate: weekOptionsData[0].weekStartDate
      }));
    }
  }, [weekOptionsData, dispatch]);

  useEffect(() => {
    if (weekOptionsData && weekOptionsData.length > 0) {
      setWeekOptions(weekOptionsData.map((week) => ({
        label: week.weekStartDate,
        value: week.weekStartDate
      })));
    }
  }, [weekOptionsData]);


  return (
    <ContentContainer mods={{ "full-width": true }}
      titleComponent={
        <ContentContainerToolbar
          title="Work with Clone Manifest"
          tooltip={"This module is in Preview. Certain data and features may be incomplete or under development."}
          status={"PREVIEW"} />
      }
    >
      <div className='clone-week-filter-section'>
        <div className='clone-week-filter-section__select'><label style={{ fontSize: "14px", lineHeight: "24px" }}>Select Week:</label>
          <XGSSelect
            name="week"
            labelMode={LabelModes.column}
            value={selectedWeek}
            isLoading={isLoadingWeeks}
            onValueChange={(v: XGSSelectOption | null | undefined) => {
              if (v) {
                setSelectedWeek(v);
                dispatch(setStaticLoad({
                  division: staticLoadSelectorData.selectedDivision,
                  weekStartDate: v.value as string
                }));
              }
            }}
            placeholder="Select"
            options={weekOptions || []}
          /></div>

        <div className='clone-week-filter-section__action'>
          <Button
            theme={ButtonThemes.blue}
            onClick={() => history.push(`/static-load`)}
            size={ButtonSizes.medium}
          >
            Back to Clone
          </Button>
          <Button
            theme={ButtonThemes.gray}
            onClick={() => {
              setIsCreateLaneSidebarOpen(true);
            }}
            type="button"
            size={ButtonSizes.medium}
          >
            Create Lane
          </Button>
        </div>
      </div>
      <WeekTabs />
      <CreateLaneSidebar
        isOpen={isCreateLaneSidebarOpen}
        onClose={() => setIsCreateLaneSidebarOpen(false)}
        isLoading={false}
      />
    </ContentContainer>
  );


};

export default WorkWithManifest;
